var map = {
	"./compact/alluvione-compact.svg": 92796,
	"./compact/frane-compact.svg": 55494,
	"./compact/fulminazione-compact.svg": 62873,
	"./compact/grandine-compact.svg": 49915,
	"./compact/pioggia-compact.svg": 21297,
	"./compact/resilienza-compact.svg": 39076,
	"./compact/sostenibilita-compact.svg": 21063,
	"./compact/sostenibilità-compact.svg": 77422,
	"./compact/temperatura-compact.svg": 40243,
	"./compact/vento-compact.svg": 31207,
	"./full/alluvione-full.svg": 2131,
	"./full/frane-full.svg": 29317,
	"./full/fulminazione-full.svg": 3675,
	"./full/grandine-full.svg": 2760,
	"./full/pioggia-full.svg": 19200,
	"./full/resilienza-full.svg": 36969,
	"./full/sostenibilita-full.svg": 21836,
	"./full/sostenibilità-full.svg": 45729,
	"./full/temperatura-full.svg": 34426,
	"./full/vento-full.svg": 94242
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 77093;